
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  errorMessage: null
};

function showErrorToast(action) {
  return action.type.endsWith('/rejected') &&
         // Permit documents actions if response code is 423 (email not verified)
         (!action.type.startsWith('document/') || action.error.message === "423" || action.error.message === "403" ||
         action.type.startsWith('document/moveImageToSection') || action.type.startsWith('document/moveImage'));
}

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    clearErrorMessage(state) {
      state.errorMessage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(showErrorToast, (state, action) => {
        state.errorMessage = action;
      });
  },
});

export const {
  clearErrorMessage
} = errorSlice.actions

export const selectErrorMessage = (state) => state.error.errorMessage;

export default errorSlice.reducer;
